import { useState, useRef } from 'react';

interface FileUploaderProps {
    onFileSelect: (file: File | null) => void;
    selectedFile: File | null;
    accept?: string;
    className?: string;
}

const FileUploader = ({ onFileSelect, selectedFile, accept = "image/*", className = "" }: FileUploaderProps) => {
    const [isDragOver, setIsDragOver] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e: React.DragEvent) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        setIsDragOver(false);
        
        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            if (file.type.startsWith('image/')) {
                onFileSelect(file);
            }
        }
    };

    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            onFileSelect(files[0]);
        }
    };

    const openFileDialog = () => {
        fileInputRef.current?.click();
    };

    const removeFile = (e: React.MouseEvent) => {
        e.stopPropagation();
        onFileSelect(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div
            className={`border-2 border-dashed p-8 rounded-lg cursor-pointer ${isDragOver ? 'border-cb-primary' : 'border-gray-300'} ${className}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={openFileDialog}
        >
            <input
                type="file"
                accept={accept}
                onChange={handleFileInputChange}
                ref={fileInputRef}
                className="hidden"
            />
            <div className="text-center">
                {selectedFile ? (
                    <div className="flex items-center justify-center">
                        <span className="mr-2">{selectedFile.name}</span>
                        <button
                            type="button"
                            onClick={removeFile}
                            className="text-red-500 hover:text-red-700"
                        >
                            X
                        </button>
                    </div>
                ) : (
                    <span>Click or drag files to this area to upload</span>
                )}
            </div>
        </div>
    );
};

export default FileUploader;
